import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth.module';
import categories from './modules/category.module';
import article from './modules/article.module';
import activity from './modules/activity.module';
import pages from './modules/pages.module';
import resource from './modules/resource.module';
import carouselSlides from './modules/carousel.module';
import { CHANGE_DOC_TITLE, PENDING, SHOW_NOTIFICATION } from '@/store/actions/app.actions';
import { SET_ERROR } from '@/store/mutations/common.mutations';
import { SET_DOC_TITLE, SET_PENDING } from '@/store/mutations/app.mutations';
import { routeBaseTitle, routeTitleSeparator } from '@/router/utils';
import { isDefined } from '@/common/utils/utils';

Vue.use(Vuex);

const state = {
  pending: false,
  errors: null,
  docTitle: routeBaseTitle
};

export default new Vuex.Store({
  state: state,
  mutations: {
    [SET_PENDING](state, pending) {
      state.pending = pending;
      state.errors = [];
    },
    [SET_ERROR](state, errors) {
      state.pending = false;
      state.errors = errors;
    },
    [SET_DOC_TITLE](state, title) {
      state.docTitle = title;
    }
  },
  actions: {
    [PENDING](context, pending) {
      context.commit(SET_PENDING, pending)
    },
    [SHOW_NOTIFICATION](context, {type, message, timeout}) {},
    [CHANGE_DOC_TITLE](context, {title, useBaseTitle}) {
      const baseTitle = isDefined(useBaseTitle) ? useBaseTitle : true;

      if (isDefined(title)) {
        if (baseTitle) {
          context.commit(SET_DOC_TITLE, `${routeBaseTitle} ${routeTitleSeparator} ${title}`)
        } else {
          context.commit(SET_DOC_TITLE, `${title}`)
        }
      } else {
        context.commit(SET_DOC_TITLE, `${routeBaseTitle}`)
      }
    },
  },
  getters: {
    appErrors(state) {
      return state.errors;
    },
    appPending(state) {
      return state.pending;
    },
    appDocTitle(state) {
      return state.docTitle;
    }
  },
  modules: {
    auth,
    categories,
    article,
    pages,
    resource,
    carouselSlides,
    activity
  }
});
